import { render, staticRenderFns } from "./FinancialMovements.vue?vue&type=template&id=0596289e"
import script from "./FinancialMovements.vue?vue&type=script&lang=js"
export * from "./FinancialMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports